<div class="modal-header">
    <h5 class="modal-title">Puantaj Detayı</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body custom-point-detail-body">

    <div class="detail-card">

        <div class="detail-row">
            <span class="label">İsim Soyisim :</span>
            <span class="value">{{ row?.name }} {{ row?.lastName }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Sicil No :</span>
            <span class="value">{{ row?.registrationNumber || '-' }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Departman :</span>
            <span class="value">{{ row?.departmentName || '-' }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Çalışma Başlangıç :</span>
            <span class="value">{{ row?.workStart | date:'dd.MM.yyyy HH:mm' }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Çalışma Bitiş :</span>
            <span class="value">{{ row?.workEnd | date:'dd.MM.yyyy HH:mm' }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Mesai (Saat) :</span>
            <span class="value">{{ row?.overtimeHours }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Çalışma Oranı :</span>
            <span class="value">{{ row?.workRate }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Açıklama :</span>
            <span class="value">{{ row?.description || '-' }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Onay Durumu :</span>
            <span class="value status-text">
                {{ getStatusText(row?.confirmed) }}
            </span>
        </div>

        <div class="detail-row">
            <span class="label">Oluşturulma Tarihi :</span>
            <span class="value">{{ formatDate(row?.cratedAt) }}</span>
        </div>

        <div class="detail-row">
            <span class="label">Güncelleme Tarihi :</span>
            <span class="value">{{ formatDate(row?.updateAt) }}</span>
        </div>

        <div class="detail-row">
            <span class="label">İşlem Yapan Kullanıcı :</span>
            <span class="value">{{ row?.appUserName || '-' }} {{ row?.appUserLastName }}</span>
        </div>

    </div>

</div>

<div class="modal-footer custom-point-detail-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Kapat</button>
</div>